import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import BlockedDomainsAPI from '../../api/blockedDomains';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getBlockedDomains($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async function getBlockedDomains({ commit }) {
    commit(types.SET_BLOCKED_DOMAINS_UI_FLAG, { isFetching: true });
    try {
      const response = await BlockedDomainsAPI.get();
      commit(types.SET_BLOCKED_DOMAINS, response.data);
      return response.data;
    } finally {
      commit(types.SET_BLOCKED_DOMAINS_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_BLOCKED_DOMAINS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_BLOCKED_DOMAINS]: MutationHelpers.set,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
